import classNames from 'classnames';
import React from 'react';

import { IconTypes } from '@eika/icon';
import { ErrorLabel } from '@eika/label';
import { ToggleSwitch } from '@eika/toggle-switch';

import './ToggleItem.scss';

type Props = {
    label: string;
    subLabel?: string;
    checked: boolean;
    onToggle: (value: boolean) => void;
    error?: string;
    // @default false;
    asHeader?: boolean;
    // @default false;
    isLoading?: boolean;
} & Omit<React.PropsWithoutRef<JSX.IntrinsicElements['button']>, 'onClick' | 'onChange'>;

const ToggleItem: React.FC<Props> = ({
    label,
    subLabel,
    checked,
    onToggle,
    children,
    error,
    asHeader = false,
    className,
    isLoading = false,
    ...rest
}) => {
    return (
        <section
            className={classNames('notifications-settings__toggle-item', className, {
                'notifications-settings__toggle-item--enabled': checked,
                'notifications-settings__toggle-item--as-header': asHeader,
            })}
        >
            <div className="notifications-settings__toggle-item-labels">
                <span className="notifications-settings__toggle-item-label semibold">{label}</span>
                {subLabel && <span className="notifications-settings__toggle-item-sublabel">{subLabel}</span>}
            </div>
            <ToggleSwitch checked={checked} onChange={onToggle} isLoading={isLoading} {...rest} />

            {error && (
                <ErrorLabel
                    icon={IconTypes.UTROPSTEGN_24}
                    text={error}
                    className="notifications-settings__toggle-item-error"
                />
            )}

            {children}
        </section>
    );
};

export default ToggleItem;
